<div class="overlay overlay-minimal">
    <div class="overlay-container-cdk">
        <h1 class="font-bold">Info</h1>
        <p class="font-regular" *ngFor="let p of content">
            {{p}}
        </p>
        <button class="iona-button orange"
                (click)="close(null)">
            Okay
        </button>
    </div>
</div>
